// extracted by mini-css-extract-plugin
export default {"toolbarButton":"QueryFilterExtension_toolbarButton__IZJ+k","active":"QueryFilterExtension_active__zTVc2","hoverEffect":"QueryFilterExtension_hoverEffect__cLJEB"};